function toggleDrawer() {
  const drawer = document.getElementById("categories-nav");
  if (drawer) {
    drawer.classList.toggle("open");
  }
}

function closeDrawer() {
  const drawer = document.getElementById("categories-nav");
  if (drawer) {
    drawer.classList.remove("open");
  }
}

function filterProjects(category) {
  const projectItems = document.querySelectorAll(
    "#vertical .media-grid__item.project-item"
  );
  const navButtons = document.querySelectorAll(".nav-button");

  console.log("Filtrando por categoría:", category);
  console.log("Elementos encontrados:", projectItems.length);

  navButtons.forEach((button) => {
    button.classList.remove("active");
  });

  const activeButton = document.querySelector(
    `.nav-button[data-category="${category}"]`
  );
  if (activeButton) {
    activeButton.classList.add("active");
  }

  projectItems.forEach((item) => {
    const itemCategories = item.getAttribute("data-categories");
    console.log("Item categorías:", itemCategories);

    if (category === "all") {
      item.classList.remove("hidden");
      console.log("Mostrando todos los items");
    } else {
      // Dividir las categorías del item y verificar si incluye la categoría seleccionada
      const categoriesArray = itemCategories ? itemCategories.split(" ") : [];
      if (categoriesArray.includes(category)) {
        item.classList.remove("hidden");
        console.log("Mostrando item con categorías:", categoriesArray);
      } else {
        item.classList.add("hidden");
        console.log("Ocultando item con categorías:", categoriesArray);
      }
    }
  });

  const selectedCategory = document.querySelector(".selected-category");
  if (selectedCategory) {
    if (category === "all") {
      selectedCategory.textContent = "Ver Todos";
    } else {
      const categoryText = activeButton ? activeButton.textContent : category;
      selectedCategory.textContent = categoryText;
    }
  }

  closeDrawer();
}

function createVideoElement(videoUrl) {
  const video = document.createElement("video");
  video.className = "video-element";
  video.autoplay = false;
  video.loop = true;
  video.muted = true;
  video.playsInline = true;
  video.setAttribute("playsinline", "");
  video.setAttribute("webkit-playsinline", "");
  video.controls = false;

  const source = document.createElement("source");
  source.src = videoUrl;
  source.type = "video/mp4";

  video.appendChild(source);
  return video;
}

function createVideoPoster(videoUrl, posterContainer) {
  const video = document.createElement("video");
  video.src = videoUrl;
  video.crossOrigin = "anonymous";
  video.preload = "metadata";

  video.addEventListener("loadeddata", function () {
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

    const posterUrl = canvas.toDataURL("image/jpeg");
    const img = document.createElement("img");
    img.src = posterUrl;
    img.className = "media-element video-thumbnail";
    img.style.width = "100%";
    img.style.height = "100%";
    img.style.objectFit = "cover";

    posterContainer.appendChild(img);
  });

  video.load();
}

function openVideoFullscreen(videoUrl) {
  const fullscreenContainer = document.createElement("div");
  fullscreenContainer.className = "video-fullscreen";

  const video = createVideoElement(videoUrl);
  video.controls = true;
  video.autoplay = true;
  video.muted = false;
  video.loop = false;

  const closeButton = document.createElement("button");
  closeButton.className = "close-video";
  closeButton.innerHTML = "×";
  closeButton.onclick = function () {
    document.body.removeChild(fullscreenContainer);
    video.pause();
  };

  fullscreenContainer.appendChild(video);
  fullscreenContainer.appendChild(closeButton);
  document.body.appendChild(fullscreenContainer);

  fullscreenContainer.onclick = function (e) {
    if (e.target === fullscreenContainer) {
      document.body.removeChild(fullscreenContainer);
      video.pause();
    }
  };
}

function isElementInViewportCenter(element) {
  const rect = element.getBoundingClientRect();
  const windowHeight =
    window.innerHeight || document.documentElement.clientHeight;

  const elementTop = rect.top;
  const elementBottom = rect.bottom;
  const elementHeight = rect.height;

  const viewportCenter = windowHeight / 2;

  const elementCenter = elementTop + elementHeight / 2;

  const viewportMiddleStart = viewportCenter - windowHeight * 0.2;
  const viewportMiddleEnd = viewportCenter + windowHeight * 0.2;

  return (
    elementCenter >= viewportMiddleStart && elementCenter <= viewportMiddleEnd
  );
}

document.addEventListener("DOMContentLoaded", function () {
  function initFiltering() {
    const navButtons = document.querySelectorAll(".nav-button");

    navButtons.forEach((button) => {
      button.addEventListener("click", function () {
        const category = this.getAttribute("data-category");
        console.log("Botón clickeado:", category);
        filterProjects(category);
      });
    });

    filterProjects("all");
  }

  function initVideos() {
    const videoContainers = document.querySelectorAll(
      '#vertical .content-over-media[data-has-video="true"]'
    );

    videoContainers.forEach((contentElement) => {
      const videoUrl = contentElement.getAttribute("data-video-url");
      const videoContainer = contentElement.querySelector(
        "[data-video-container]"
      );
      const posterContainer = contentElement.querySelector(
        "[data-video-poster]"
      );

      if (!videoUrl || !videoContainer) return;

      const videoElement = createVideoElement(videoUrl);
      videoContainer.appendChild(videoElement);

      if (posterContainer) {
        createVideoPoster(videoUrl, posterContainer);
      }
    });
  }

  function initMediaHover() {
    const contentOverMediaElements = document.querySelectorAll(
      '#vertical .content-over-media[data-has-video="true"]'
    );

    contentOverMediaElements.forEach((contentElement) => {
      const videoContainer = contentElement.querySelector(
        "[data-video-container]"
      );
      const videoElement = videoContainer
        ? videoContainer.querySelector("video")
        : null;
      const thumbnailContainer = contentElement.querySelector(
        "[data-video-thumbnail]"
      );

      if (!videoElement) return;

      let hoverTimeout;
      let isHovered = false;

      function startHover() {
        if (window.innerWidth < 700) return;

        clearTimeout(hoverTimeout);
        isHovered = true;
        contentElement.classList.add("is-hovered");

        if (videoContainer) {
          videoContainer.style.display = "block";
          setTimeout(() => {
            videoContainer.style.opacity = "1";
          }, 10);
        }

        videoElement.currentTime = 0;
        const playPromise = videoElement.play();

        if (playPromise !== undefined) {
          playPromise.catch((error) => {
            console.log("Error al reproducir video:", error);
            videoElement.muted = true;
            videoElement.play().catch((e) => {
              console.log("Error persistente:", e);
            });
          });
        }
      }

      function endHover() {
        if (window.innerWidth < 700) return;

        clearTimeout(hoverTimeout);
        hoverTimeout = setTimeout(() => {
          if (!contentElement.matches(":hover")) {
            isHovered = false;
            contentElement.classList.remove("is-hovered");

            if (videoContainer) {
              //videoContainer.style.opacity = "0";
              setTimeout(() => {
                if (!isHovered) {
                  //videoContainer.style.display = "none";
                }
              }, 300);
            }

            videoElement.pause();
            videoElement.currentTime = 0;
          }
        }, 50);
      }

      if (window.innerWidth >= 700) {
        contentElement.addEventListener("mouseenter", function (e) {
          if (!e.relatedTarget || !contentElement.contains(e.relatedTarget)) {
            startHover();
          }
        });

        contentElement.addEventListener("mouseleave", function (e) {
          if (!e.relatedTarget || !contentElement.contains(e.relatedTarget)) {
            endHover();
          }
        });
      }
    });
  }

  function initMobileVideo() {
    if (window.innerWidth >= 700) return;

    const playIcons = document.querySelectorAll("#vertical [data-video-play]");

    playIcons.forEach((playIcon) => {
      playIcon.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();

        const contentElement = this.closest(".content-over-media");
        const videoUrl = contentElement.getAttribute("data-video-url");

        if (videoUrl) {
          openVideoFullscreen(videoUrl);
        }
      });
    });
  }

  function initMobileAutoPlay() {
    if (window.innerWidth >= 700) return;

    const videoElements = document.querySelectorAll(
      '#vertical .content-over-media[data-has-video="true"] .video-element'
    );

    function checkVideosInViewport() {
      videoElements.forEach((videoElement) => {
        const contentElement = videoElement.closest(".content-over-media");
        const videoContainer = contentElement.querySelector(
          "[data-video-container]"
        );

        if (isElementInViewportCenter(contentElement)) {
          if (videoElement.paused) {
            videoElement.currentTime = 0;
            const playPromise = videoElement.play();

            if (playPromise !== undefined) {
              playPromise.catch((error) => {
                console.log(
                  "Error al reproducir video automáticamente:",
                  error
                );
              });
            }

            contentElement.classList.add("mobile-video-active");
          }
        } else {
          if (!videoElement.paused) {
            videoElement.pause();
            videoElement.currentTime = 0;
          }
          contentElement.classList.remove("mobile-video-active");
        }
      });
    }

    checkVideosInViewport();
    window.addEventListener("scroll", checkVideosInViewport);
    window.addEventListener("resize", checkVideosInViewport);
  }

  if (
    document.querySelectorAll("#vertical .media-grid__item.project-item")
      .length > 0
  ) {
    initFiltering();
    initVideos();
    initMediaHover();
    initMobileVideo();
    initMobileAutoPlay();
  }

  let resizeTimeout;
  window.addEventListener("resize", function () {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      initMediaHover();
      initMobileVideo();
      initMobileAutoPlay();
    }, 250);
  });
});
